import { render, staticRenderFns } from "./UpgradeTableOverlay.vue?vue&type=template&id=fb5ef066"
import script from "./UpgradeTableOverlay.vue?vue&type=script&lang=js"
export * from "./UpgradeTableOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports